import { WPSKnowledgeBaseAPI } from '@/constants/API';
import { request } from '@umijs/max';
import { fetchEventSource } from '@microsoft/fetch-event-source';
import qs from 'qs';

//查询已关联的团队文档列表
export async function queryAssociatedTeamDocList(params: any) {
  return request(`${WPSKnowledgeBaseAPI}/queryAssociatedTeamDocList?${qs.stringify(params)}`);
}

//删除已关联的文档
export async function deleteAssociatedTeamDoc(params: any) {
  return request(`${WPSKnowledgeBaseAPI}/deleteById/${params.id}`, {
    method: 'DELETE',
  });
}

/**
 * 根据团队id数组查询对应切片进度(SSE)
 * @param params - 请求参数
 * @param callback - 消息回调函数
 * @param signal - AbortSignal 用于取消请求
 * @returns Promise
 */
export async function queryTeamDocSliceProgress(
  params: any,
  callback: (event: any) => void,
  signal?: AbortSignal
) {
  return fetchEventSource(`${WPSKnowledgeBaseAPI}/querySliceProgress`, {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/json',
      "Authorization": `Bearer ${localStorage.getItem("user_token")}`,
    },
    signal,
    onmessage: (event) => {
      callback(event)
    },
    onclose: () => {
      console.log("Connection closed by the server");
    },
    onerror: (err) => {
      console.error("EventSource failed:", err);
      throw err;
    },
    openWhenHidden: true,
  });
}

//查询wps团队文档列表
export async function queryWpsTeamDocList() {
  return request(`${WPSKnowledgeBaseAPI}/queryWpsTeamDocList?appId=4`);
}

//保存团队文档
export async function saveTeamDoc(params: any) {
  return request(`${WPSKnowledgeBaseAPI}/saveTeamDoc`, {
    method: 'POST',
    data: params,
  });
}
